import React from 'react'

const DefaultPage = React.lazy(() => import('./DefaultPage'))

export default {
  path: 'cognito',
  name: 'Cognito',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/cognito/route.js